import React, { CSSProperties } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "ducks/state";
import { loadMarketplaceRecipients, recipientsView } from "ducks/marketplace";
import { LinearProgress } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { Link } from "react-router-dom";
import { RecipientStatus } from "@udok/lib/api/models";

type WarnNoRecipientProps = {
  style?: CSSProperties;
  onChange?: (value: boolean) => void;
};

const WarnNoRecipient = React.forwardRef(
  (props: WarnNoRecipientProps, ref: React.Ref<any>) => {
    const { style, onChange } = props;
    const [loading, setLoading] = React.useState(false);
    const [fetched, setFetched] = React.useState(false);
    const dispatch: AppDispatch = useDispatch();
    const { list } = useSelector(recipientsView);

    React.useEffect(() => {
      setLoading(true);
      dispatch(loadMarketplaceRecipients())
        .then(() => setFetched(true))
        .catch(console.warn)
        .finally(() => {
          setLoading(false);
        });
    }, [dispatch]);

    const defaultRecipient = list?.filter?.(
      (recipient) => recipient.activatedAt !== null
    );

    const noRecipientRegistered = fetched && list.length === 0;
    const noRecipientActivated =
      fetched && defaultRecipient?.[0]?.status !== RecipientStatus.active;

    React.useEffect(() => {
      onChange?.(noRecipientRegistered || noRecipientActivated);
    }, [noRecipientRegistered, noRecipientActivated, onChange]);

    return (
      <div ref={ref} style={style}>
        {loading ? <LinearProgress color="primary" /> : null}
        {noRecipientRegistered || noRecipientActivated ? (
          <Alert severity="warning">
            <span>
              {noRecipientRegistered ? (
                <>
                  Você ainda não possui uma conta bancária cadastrada para
                  recebimento.{" "}
                  <Link to="/admin/finances/bank-accounts/create">
                    Clique aqui
                  </Link>{" "}
                  <span>para iniciar o cadastro</span>
                </>
              ) : noRecipientActivated ? (
                <>
                  Sua conta bancária ainda não foi habilitada para transações.{" "}
                  <Link
                    to={`/admin/finances/bank-accounts/${defaultRecipient?.[0]?.mareID}`}
                  >
                    Clique aqui
                  </Link>{" "}
                  <span>e finalize a validação.</span>
                </>
              ) : (
                ""
              )}
            </span>{" "}
          </Alert>
        ) : null}
      </div>
    );
  }
);

export default WarnNoRecipient;
